(function () {
  // ---------- Helpers ----------
  function closestGallery(el) {
    return el && el.closest ? el.closest(".mv-gallery") : null;
  }

  function getMainImg(gallery) {
    return gallery.querySelector(".mv-main-img");
  }

  function getAllFullUrls(gallery) {
    return Array.from(gallery.querySelectorAll("img[data-full]"))
      .map((img) => img.getAttribute("data-full"))
      .filter(Boolean);
  }

  function getCurrentIndex(list, currentSrc) {
    if (!list.length) return 0;
    let i = list.findIndex((u) => u === currentSrc);
    if (i === -1 && currentSrc) i = list.findIndex((u) => currentSrc.includes(u));
    return i === -1 ? 0 : i;
  }

  function setMain(gallery, src) {
    const mainImg = getMainImg(gallery);
    if (!mainImg || !src) return;
    mainImg.src = src;
  }

  // ---------- Make +X toggle always work (even with page transitions) ----------
  document.addEventListener(
    "click",
    function (e) {
      const t = e.target;

      // Thumb click
      const thumbImg = t && t.matches ? (t.matches("img[data-full]") ? t : null) : null;
      if (thumbImg) {
        const gallery = closestGallery(thumbImg);
        if (!gallery) return;
        setMain(gallery, thumbImg.getAttribute("data-full"));
        return;
      }

      // Plus toggle
      const plusBtn = t && t.closest ? t.closest("[data-mv-plus]") : null;
      if (plusBtn) {
        const gallery = closestGallery(plusBtn);
        if (!gallery) return;

        const more = gallery.querySelector("[data-mv-more]");
        if (!more) return;

        // store original "+8" once
        if (!plusBtn.dataset.originalText) {
          plusBtn.dataset.originalText = plusBtn.textContent.trim();
        }

        const open = more.classList.toggle("is-open");
        plusBtn.textContent = open ? "–" : plusBtn.dataset.originalText;
        return;
      }

      // Prev / Next
      const prevBtn = t && t.closest ? t.closest("[data-mv-prev]") : null;
      const nextBtn = t && t.closest ? t.closest("[data-mv-next]") : null;

      if (prevBtn || nextBtn) {
        const btn = prevBtn || nextBtn;
        const gallery = closestGallery(btn);
        if (!gallery) return;

        const list = getAllFullUrls(gallery);
        const mainImg = getMainImg(gallery);
        if (!mainImg || !list.length) return;

        const dir = prevBtn ? -1 : 1;
        const i = getCurrentIndex(list, mainImg.getAttribute("src"));
        const next = (i + dir + list.length) % list.length;
        setMain(gallery, list[next]);
        return;
      }
    },
    true
  );
})();
